import { OrganizationCountry } from "../enums/country";
export const isUsSmsSenderCountry = (country) => country === OrganizationCountry.UnitedStates;
export const isCanadaSmsSenderCountry = (country) => country === OrganizationCountry.Canada;
export const isSmsSenderSupportedCountry = (country) => isUsSmsSenderCountry(country) || isCanadaSmsSenderCountry(country);
